import {
  useNavigateWithPersistParams,
  useReselector,
} from '@/utils/sharedHooks'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import {
  selectCanOptIntoPreviousTaxYear,
  selectCurrentAnnualTaxYear,
} from '@/featuresV1/Admin/AnnualTaxDetails/annualTaxDetails.selector'
import { SIGNUP_PATHS } from '../helpers'

import { SignupHeader } from '../SignupHeader'
import { TypographyStyles } from '@/styles'
import { Button, Separator, Text } from '@/ui'

export const Disqualified = () => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  const navigate = useNavigateWithPersistParams()
  const canOptIntoPreviousYearTaxes = useReselector(
    selectCanOptIntoPreviousTaxYear
  )
  const currentStep = canOptIntoPreviousYearTaxes ? 3 : 2
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)

  return (
    <div className="container mx-auto pt-16">
      <div className="flex flex-col space-y-4">
        <SignupHeader currentStep={currentStep} />

        <Text variant={TypographyStyles.BODY_LG} className="mb-4">
          <b>
            We&apos;re working hard to prepare for this year&apos;s tax season.
          </b>
        </Text>

        <Text className="mb-4">
          Helping you file your taxes for this year (
          {Number(currentTaxYear) + 1}) is part of your plan.
        </Text>

        <Text className="mb-4">
          However, we are unable to help you file your taxes for last year (
          {currentTaxYear}). If you still need help with your {currentTaxYear}{' '}
          taxes, we recommend seeking assistance outside of Heard.
        </Text>

        <Separator />

        {!isMobile ? (
          <div className="flex justify-between">
            <div className="w-1/6">
              <Button
                variant="secondary"
                onClick={() => navigate(SIGNUP_PATHS.practiceJourney)}
              >
                Back
              </Button>
            </div>

            <div className="w-1/6">
              <Button
                onClick={() => navigate(SIGNUP_PATHS.choosePlan)}
                id="btn-signup-previous-year-form"
              >
                Continue
              </Button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col space-y-4">
            <Button
              onClick={() => navigate(SIGNUP_PATHS.choosePlan)}
              id="btn-signup-previous-year-form"
            >
              Continue
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate(SIGNUP_PATHS.aboutYourPractice)}
            >
              Back
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
